
import Vue from 'vue';

export default Vue.extend({
  name: 'WarningDialog',
  props: {
    value: Boolean,
  },
  data() {
    return {
      dialog: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
    },
    dialog(newVal) {
      this.$emit('input', newVal);
    },
  },
  methods: {
    cancel() {
      this.$emit('cancelAction');
    },
    confirm() {
      this.$emit('confirmAction');
    },
  },
});
